export default function useInputRules(rules: Function[], value: any) {
    let newRules: any[] = []

    rules.map(rule => newRules.push(() => rule(value)))

    return newRules
}

export { useInputRules }
